import React from 'react';
import PropTypes from 'prop-types';
// Components
import { GlobalStyle } from '../theme/global';
// Utils
import LayoutContext from './context';
import { SafeTemplate } from '../error-boundaries';

const Layout = ({ children }) => (
  <LayoutContext.Provider>
    <GlobalStyle />
    <main id="main">{children}</main>
  </LayoutContext.Provider>
);
Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SafeTemplate(Layout);
